import { del, get, patch, post } from '../../utils/api'
import { AxiosResponse } from 'axios'

export const fetchModulesList = (id: string): Promise<AxiosResponse> =>
  get(`/courses/courses/${id}/modules`, {
    include: 'moduleRelationsBlocks,moduleRelationsCount',
  })

export const removeModule = (id: string): Promise<AxiosResponse> =>
  del(`/courses/modules/${id}`)

export const createModuleRelation = (
  sourceId: string,
  targetId: string,
  relationType: string
): Promise<AxiosResponse> =>
  post('/courses/module-relations', {
    source_module_id: sourceId,
    target_module_id: targetId,
    type: relationType,
  })

export const editModuleRelation = (
  relationId: string,
  sourceId: string,
  targetId: string,
  relationType: string
): Promise<AxiosResponse> =>
  patch(`/courses/module-relations/${relationId}`, {
    source_module_id: sourceId,
    target_module_id: targetId,
    type: relationType,
  })

export const removeModuleRelation = (id: string): Promise<AxiosResponse> =>
  del(`/courses/module-relations/${id}`)
